import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { Buildings } from "../apis/dto/Buildings";
import { Department } from "../apis/dto/Department";
import {
  DepartmentAdmin,
  DepartmentDetail,
} from "../apis/dto/DepartmentDetail";
import idm from "../apis/idm";
import { ErrorToastr } from "../components/utility/ErrorToastr";

export const fetchDepartments = createAsyncThunk<Department[], void>(
  "departments",
  async (_, thunkApi) => {
    try {
      const response = await idm.get("/departments", {
        withCredentials: true,
      });

      if (typeof response.data == "object") {
        return response.data as Department[];
      } else {
        throw new Error("Error - " + response.data);
      }
    } catch (err: any) {
      let error: AxiosError = err; // cast the error for access
      if (!error.response) {
        throw err;
      }

      const meta = { errorMessage: err.message, status: error.response.status };
      const response = { responseMessage: error.response.data, meta: meta };
      return thunkApi.rejectWithValue(response);
    }
  }
);

export interface userDeptAdmin {
  deptCode: string;
  ucmNetId: string;
}

export const deleteDepartmentAdmin = createAsyncThunk<
  userDeptAdmin,
  userDeptAdmin
>("deleteDepartmentAdmin", async (data: userDeptAdmin, thunkApi) => {
  try {
    const { deptCode, ucmNetId } = data;
    const response = await idm.delete(
      `/department/removeAdmin/${deptCode}/${ucmNetId}`,
      {
        withCredentials: true,
      }
    );

    if (response.status !== 204) {
      throw new Error("Error - " + response.data);
    }

    return data as userDeptAdmin;
  } catch (err: any) {
    let error: AxiosError = err; // cast the error for access
    if (!error.response) {
      throw err;
    }
    const meta = { errorMessage: err.message, status: error.response.status };
    const response = { responseMessage: error.response.data, meta: meta };
    return thunkApi.rejectWithValue(response);
  }
});

interface userAndDepartment {
  departmentAdmin: DepartmentAdmin;
  userDepartmentAdmin: userDeptAdmin;
}
export const addDepartmentAdmin = createAsyncThunk<
  userAndDepartment,
  userDeptAdmin
>("addDepartmentAdmin", async (data: userDeptAdmin, thunkApi) => {
  try {
    const { deptCode, ucmNetId } = data;

    const response = await idm.post(
      `/department/addAdmin/${deptCode}/${ucmNetId}`,
      null,
      {
        withCredentials: true,
      }
    );

    if (response.status !== 201) {
      throw new Error("Error - " + response.data);
    }

    return {
      departmentAdmin: response.data as DepartmentAdmin,
      userDepartmentAdmin: data,
    } as userAndDepartment;

    //return data as userDeptAdmin;
  } catch (err: any) {
    let error: AxiosError = err; // cast the error for access
    if (!error.response) {
      throw err;
    }
    const meta = { errorMessage: err.message, status: error.response.status };
    const response = { responseMessage: error.response.data, meta: meta };
    return thunkApi.rejectWithValue(response);
  }
});

export const updateDepartmentPreferences = createAsyncThunk<
  DepartmentDetail,
  DepartmentDetail
>(
  "updateDepartmentPreferences",

  async (data: DepartmentDetail, thunkApi) => {
    try {
      const response = await idm.post("/department/preferences", data, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error("Error - " + response.data);
      }

      return data as DepartmentDetail;
    } catch (err: any) {
      let error: AxiosError = err; // cast the error for access
      if (!error.response) {
        throw err;
      }
      const meta = { errorMessage: err.message, status: error.response.status };
      const response = { responseMessage: error.response.data, meta: meta };
      return thunkApi.rejectWithValue(response);
    }
  }
);

export interface SearchUserAdmin {
  deptCode: string;
  searchTerm: string;
}
export const fetchSearchUserAdmin = createAsyncThunk<
  DepartmentAdmin[],
  SearchUserAdmin
>(
  "fetchSearchUserAdmin",

  async (params: SearchUserAdmin, thunkApi) => {
    try {
      const { deptCode, searchTerm } = params;
      const response = await idm.get(
        `/department/adminSearch/${deptCode}/${searchTerm}`,
        {
          withCredentials: true,
        }
      );

      if (typeof response.data == "object") {
        return response.data as DepartmentAdmin[];
      } else {
        throw new Error("Error - " + response.data);
      }
    } catch (err: any) {
      let error: AxiosError = err; // cast the error for access
      if (!error.response) {
        // const meta = { errorMessage: 'Unknown Exception', status: '400' }
        // const response = { responseMessage : 'Contact Help Desk', meta: meta}
        // thunkApi.rejectWithValue(response);
        throw err;
      }

      const meta = { errorMessage: err.message, status: error.response.status };
      const response = {
        responseMessage: error.response.data,
        meta: meta,
        data: params.searchTerm,
      };
      return thunkApi.rejectWithValue(response);
    }
  }
);

export const fetchBuildings = createAsyncThunk<Buildings[], void>(
  "buildings",
  async (_, thunkApi) => {
    try {
      const response = await idm.get("/buildings/department", {
        withCredentials: true,
      });

      if (typeof response.data == "object") {
        return response.data as Buildings[];
      } else {
        throw new Error("Error - " + response.data);
      }
    } catch (err: any) {
      let error: AxiosError = err; // cast the error for access
      if (!error.response) {
        // const meta = { errorMessage: 'Unknown Exception', status: '400' }
        // const response = { responseMessage : 'Contact Help Desk', meta: meta}
        // thunkApi.rejectWithValue(response);
        throw err;
      }

      const meta = { errorMessage: err.message, status: error.response.status };
      const response = { responseMessage: error.response.data, meta: meta };
      return thunkApi.rejectWithValue(response);
    }
  }
);

export const fetchBuildingsPersonnel = createAsyncThunk<Buildings[], void>(
  "buildingsPersonnel",
  async (_, thunkApi) => {
    try {
      const response = await idm.get("/buildings/personnel", {
        withCredentials: true,
      });

      if (typeof response.data == "object") {
        return response.data as Buildings[];
      } else {
        throw new Error("Error - " + response.data);
      }
    } catch (err: any) {
      let error: AxiosError = err; // cast the error for access
      if (!error.response) {
        // const meta = { errorMessage: 'Unknown Exception', status: '400' }
        // const response = { responseMessage : 'Contact Help Desk', meta: meta}
        // thunkApi.rejectWithValue(response);
        throw err;
      }

      const meta = { errorMessage: err.message, status: error.response.status };
      const response = { responseMessage: error.response.data, meta: meta };
      return thunkApi.rejectWithValue(response);
    }
  }
);

export const fetchDepartmentByDeptCode = createAsyncThunk<
  DepartmentDetail | null,
  string
>("department/DeptCode", async (deptCode: string, thunkApi) => {
  try {
    const state = thunkApi.getState() as any;
    const departmentState = state.departments as DepartmentState;
    if (
      departmentState.departmentDetail.entities &&
      departmentState.departmentDetail.entities.find(
        (dept) => dept.deptCode === deptCode
      )
    ) {
      return null;
    }
    const response = await idm.get(`/department/${deptCode}`, {
      withCredentials: true,
    });

    if (typeof response.data == "object") {
      return response.data as DepartmentDetail;
    } else {
      throw new Error("Error - " + response.data);
    }
  } catch (err: any) {
    let error: AxiosError = err; // cast the error for access
    if (!error.response) {
      // const meta = { errorMessage: 'Unknown Exception', status: '400' }
      // const response = { responseMessage : 'Contact Help Desk', meta: meta}
      // thunkApi.rejectWithValue(response);
      throw err;
    }

    const meta = { errorMessage: err.message, status: error.response.status };
    const response = { responseMessage: error.response.data, meta: meta };
    return thunkApi.rejectWithValue(response);
  }
});

export interface BuildingsState {
  error: ErrorToastr | null | undefined;
  loading: "idle" | "pending" | "succeeded" | "failed";
  entities: Buildings[];
}

export interface BuildingsPersonnelState {
  error: ErrorToastr | null | undefined;
  loading: "idle" | "pending" | "succeeded" | "failed";
  entities: Buildings[];
}

export interface DepartmentDetailsState {
  error: ErrorToastr | null | undefined;
  loading: "idle" | "pending" | "succeeded" | "failed";
  entities: DepartmentDetail[];
}

export interface UserAdminState {
  error: ErrorToastr | null | undefined;
  loading: "idle" | "pending" | "succeeded" | "failed";
  entities: DepartmentAdmin[];
}

interface DepartmentState {
  searchUserAdmins: UserAdminState;
  buildings: BuildingsState;
  buildingsPersonnel: BuildingsPersonnelState;
  departmentDetail: DepartmentDetailsState;
  error: ErrorToastr | null | undefined;
  loading: "idle" | "pending" | "succeeded" | "failed";
  entities: Record<string, Department>[];
}

// Then, handle actions in your reducers:
const departmentSlice = createSlice({
  name: "users",
  initialState: {
    searchUserAdmins: {
      error: null,
      loading: "idle",
      entities: [],
    },
    buildings: {
      error: null,
      loading: "idle",
      entities: [],
    },
    buildingsPersonnel: {
      error: null,
      loading: "idle",
      entities: [],
    },
    departmentDetail: {
      error: null,
      loading: "idle",
      entities: [],
    },
    entities: [],
    loading: "idle",
    error: null,
  } as DepartmentState,
  reducers: {
    resetSearchResults: (state, action: any) => {
      state.searchUserAdmins.entities = [];
    },
    setLoading: (
      state,
      action: PayloadAction<"idle" | "pending" | "succeeded" | "failed">
    ) => {
      state.searchUserAdmins.loading = action.payload;
    },
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
        }
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        const data = action.payload.map<Record<string, Department>>((x) => {
          return { [x.deptCode]: x };
        });
        state.entities.push(...data);
        state.loading = "idle";
      })
      .addCase(fetchDepartments.rejected, (state: any, action: any) => {
        // const { requestId } = action.meta;
        // if (state.loading === "pending") {
        //   state.error = action.error.message;
        //   state.loading = "idle";
        // }
        if (action.payload) {
          const errorObj: ErrorToastr = {
            title: "!Error - " + action.payload.meta.status,
            message:
              action.payload && action.payload.responseMessage.message
                ? action.payload.responseMessage.message
                : action.payload.meta.errorMessage,
          };
          state.error = errorObj;
        } else {
          const errorObj: ErrorToastr = {
            title: "!Unknown Error",
            message: "Contact Help Desk - " + action.error.message,
          };
          state.error = errorObj;
        }

        state.loading = "failed";
      })
      .addCase(fetchDepartmentByDeptCode.pending, (state, action) => {
        if (state.departmentDetail.loading === "idle") {
          state.departmentDetail.loading = "pending";
        }
      })
      .addCase(
        fetchDepartmentByDeptCode.fulfilled,
        (state, action: PayloadAction<DepartmentDetail | null>) => {
          if (action && action.payload) {
            state.departmentDetail.entities.push(action.payload);
          }
          state.departmentDetail.loading = "idle";
        }
      )
      .addCase(
        fetchDepartmentByDeptCode.rejected,
        (state: any, action: any) => {
          // const { requestId } = action.meta;
          // if (state.departmentDetail.loading === "pending") {
          //   state.departmentDetail.loading = "idle";
          //   state.departmentDetail.error = action.error.message;
          // }
          if (state.departmentDetail) {
            if (action.payload) {
              const errorObj: ErrorToastr = {
                title: "!Error - " + action.payload.meta.status,
                message:
                  action.payload && action.payload.responseMessage.message
                    ? action.payload.responseMessage.message
                    : action.payload.meta.errorMessage,
              };
              state.departmentDetail.error = errorObj;
            } else {
              const errorObj: ErrorToastr = {
                title: "!Unknown Error",
                message: "Contact Help Desk - " + action.error.message,
              };
              state.departmentDetail.error = errorObj;
            }

            state.departmentDetail.loading = "failed";
          }
        }
      )
      .addCase(fetchBuildings.pending, (state, action) => {
        if (state.buildings.loading === "idle") {
          state.buildings.loading = "pending";
        }
      })
      .addCase(fetchBuildings.rejected, (state: any, action: any) => {
        // const { requestId } = action.meta;
        // if (state.buildings.loading === "pending") {
        //   state.buildings.error = action.error.message;
        //   state.buildings.loading = "idle";
        // }

        if (state.buildings) {
          if (action.payload) {
            const errorObj: ErrorToastr = {
              title: "!Error - " + action.payload.meta.status,
              message:
                action.payload && action.payload.responseMessage.message
                  ? action.payload.responseMessage.message
                  : action.payload.meta.errorMessage,
            };
            state.buildings.error = errorObj;
          } else {
            const errorObj: ErrorToastr = {
              title: "!Unknown Error",
              message: "Contact Help Desk - " + action.error.message,
            };
            state.buildings.error = errorObj;
          }

          state.buildings.loading = "failed";
        }
      })
      .addCase(
        fetchBuildings.fulfilled,
        (state, action: PayloadAction<Buildings[]>) => {
          state.buildings.entities = action.payload;
          state.buildings.loading = "idle";
        }
      )

      .addCase(fetchBuildingsPersonnel.pending, (state, action) => {
        if (state.buildingsPersonnel.loading === "idle") {
          state.buildingsPersonnel.loading = "pending";
        }
      })
      .addCase(fetchBuildingsPersonnel.rejected, (state: any, action: any) => {
        // const { requestId } = action.meta;
        // if (state.buildingsPersonnel.loading === "pending") {
        //   state.buildingsPersonnel.error = action.error.message;
        //   state.buildingsPersonnel.loading = "idle";
        // }

        if (state.buildingsPersonnel) {
          if (action.payload) {
            const errorObj: ErrorToastr = {
              title: "!Error - " + action.payload.meta.status,
              message:
                action.payload && action.payload.responseMessage.message
                  ? action.payload.responseMessage.message
                  : action.payload.meta.errorMessage,
            };
            state.buildingsPersonnel.error = errorObj;
          } else {
            const errorObj: ErrorToastr = {
              title: "!Unknown Error",
              message: "Contact Help Desk - " + action.error.message,
            };
            state.buildingsPersonnel.error = errorObj;
          }

          state.buildingsPersonnel.loading = "failed";
        }
      })
      .addCase(
        fetchBuildingsPersonnel.fulfilled,
        (state, action: PayloadAction<Buildings[]>) => {
          state.buildingsPersonnel.entities = action.payload;
          state.buildingsPersonnel.loading = "idle";
        }
      )
      .addCase(updateDepartmentPreferences.pending, (state, action) => {
        if (state.departmentDetail.loading === "idle") {
          state.departmentDetail.loading = "pending";
        }
      })
      .addCase(
        updateDepartmentPreferences.fulfilled,
        (state, action: PayloadAction<DepartmentDetail>) => {
          if (action && action.payload) {
            state.departmentDetail.entities =
              state.departmentDetail.entities.filter(
                (d) => d.deptCode !== action.payload.deptCode
              );
            state.departmentDetail.entities.push(action.payload);
          }
          state.departmentDetail.loading = "idle";
        }
      )
      .addCase(
        updateDepartmentPreferences.rejected,
        (state: any, action: any) => {
          if (state.departmentDetail) {
            if (action.payload) {
              state.departmentDetail.error = {
                title: "!Error - " + action.payload.meta.status,
                message:
                  action.payload && action.payload.responseMessage.message
                    ? action.payload.responseMessage.message
                    : action.payload.meta.errorMessage,
              };
            } else {
              state.departmentDetail.error = {
                title: "!Unknown Error",
                message: "Contact Help Desk - " + action.error.message,
              };
            }

            state.departmentDetail.loading = "failed";
          }
        }
      )
      .addCase(fetchSearchUserAdmin.pending, (state, action) => {
        if (state.searchUserAdmins.loading !== "pending") {
          state.searchUserAdmins.entities = [];
          state.searchUserAdmins.loading = "pending";
        }
      })
      .addCase(
        fetchSearchUserAdmin.fulfilled,
        (state, action: PayloadAction<DepartmentAdmin[]>) => {
          if (action && action.payload) {
            state.searchUserAdmins.entities.push(...action.payload);
          }
          state.searchUserAdmins.loading = "succeeded";
        }
      )
      .addCase(fetchSearchUserAdmin.rejected, (state: any, action: any) => {
        // if (state.searchUserAdmins.loading === "pending") {
        //   state.searchUserAdmins.loading = "failed";
        //   state.searchUserAdmins.error = action.error.message;
        // }
        if (state.searchUserAdmins) {
          if (action.payload) {
            const errorObj: ErrorToastr = {
              title: "!Error - " + action.payload.meta.status,
              message:
                action.payload && action.payload.responseMessage.message
                  ? action.payload.responseMessage.message
                  : action.payload.meta.errorMessage,
              data: action.payload.data,
            };
            state.searchUserAdmins.error = errorObj;
          } else {
            const errorObj: ErrorToastr = {
              title: "!Unknown Error",
              message: "Contact Help Desk - " + action.error.message,
              data: action.payload.data,
            };
            state.searchUserAdmins.error = errorObj;
          }

          state.searchUserAdmins.loading = "failed";
        }
      })
      .addCase(addDepartmentAdmin.pending, (state, action) => {
        if (state.searchUserAdmins.loading !== "pending") {
          state.searchUserAdmins.loading = "pending";
        }
      })
      .addCase(
        addDepartmentAdmin.fulfilled,
        (state, action: PayloadAction<userAndDepartment>) => {
          if (action && action.payload) {
            const departmentDetailFound = state.departmentDetail.entities.find(
              (dept) =>
                dept.deptCode === action.payload.userDepartmentAdmin.deptCode
            );
            departmentDetailFound?.admins.push(action.payload.departmentAdmin);
            state.searchUserAdmins.entities = [];
          }
          state.searchUserAdmins.loading = "succeeded";
        }
      )
      .addCase(addDepartmentAdmin.rejected, (state: any, action: any) => {
        // if (state.searchUserAdmins.loading === "pending") {
        //   state.searchUserAdmins.loading = "failed";
        //   state.searchUserAdmins.error = action.error.message;
        // }
        if (state.searchUserAdmins) {
          if (action.payload) {
            const errorObj: ErrorToastr = {
              title: "!Error - " + action.payload.meta.status,
              message:
                action.payload && action.payload.responseMessage.message
                  ? action.payload.responseMessage.message
                  : action.payload.meta.errorMessage,
            };
            state.searchUserAdmins.error = errorObj;
          } else {
            const errorObj: ErrorToastr = {
              title: "!Unknown Error",
              message: "Contact Help Desk - " + action.error.message,
            };
            state.searchUserAdmins.error = errorObj;
          }

          state.searchUserAdmins.loading = "failed";
        }
      })

      .addCase(deleteDepartmentAdmin.pending, (state, action) => {
        if (state.searchUserAdmins.loading !== "pending") {
          state.searchUserAdmins.loading = "pending";
        }
      })
      .addCase(
        deleteDepartmentAdmin.fulfilled,
        (state, action: PayloadAction<userDeptAdmin>) => {
          if (action && action.payload) {
            const departmentDetailFound = state.departmentDetail.entities.find(
              (dept) => dept.deptCode === action.payload.deptCode
            );
            if (departmentDetailFound?.admins) {
              departmentDetailFound.admins =
                departmentDetailFound?.admins.filter(
                  (admin) => admin.ucmnetid !== action.payload.ucmNetId
                );
            }
          }
          state.searchUserAdmins.loading = "succeeded";
        }
      )
      .addCase(deleteDepartmentAdmin.rejected, (state: any, action: any) => {
        // if (state.searchUserAdmins.loading === "pending") {
        //   state.searchUserAdmins.loading = "failed";
        //   state.searchUserAdmins.error = action.error.message;
        // }

        if (state.searchUserAdmins) {
          if (action.payload) {
            const errorObj: ErrorToastr = {
              title: "!Error - " + action.payload.meta.status,
              message:
                action.payload && action.payload.responseMessage.message
                  ? action.payload.responseMessage.message
                  : action.payload.meta.errorMessage,
            };
            state.searchUserAdmins.error = errorObj;
          } else {
            const errorObj: ErrorToastr = {
              title: "!Unknown Error",
              message: "Contact Help Desk - " + action.error.message,
            };
            state.searchUserAdmins.error = errorObj;
          }

          state.searchUserAdmins.loading = "failed";
        }
      });
  },
});

export const { resetSearchResults, setLoading } = departmentSlice.actions;
export default departmentSlice.reducer;
